import axios from 'axios';

export default axios.create({
    baseURL: 'http://109.199.103.73:5050'
    // baseURL: 'http://localhost:8081'
    // baseURL: 'http://167.86.86.168:8081'
});
